import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PUBLIC_MEDREFILL_COLLECTIONS_LIST_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetCollectionListResult, GetPublicCollectionListPayload } from '../types/getCollectionList.type';

export const TAG_PUBLIC_MEDREFILL_COLLECTION_LIST = 'getPublicCollectionList';

export const getPublicCollectionList = <T extends BuilderType>(builder: T) =>
  builder.query<GetCollectionListResult, GetPublicCollectionListPayload>({
    providesTags: [TAG_PUBLIC_MEDREFILL_COLLECTION_LIST],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: GET_PUBLIC_MEDREFILL_COLLECTIONS_LIST_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetCollectionListResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
